import Typograf from 'typograf';

const tp = new Typograf({ locale: ['ru', 'en-US'] });

const typograf = (text) => tp.execute(text);

export default typograf;
